<template>
  <K2Row class="filterList customScroll">
    <K2Text class-name="me-3" link="true" v-for="nav of postNavList" :color="nav.color" @onclick="() => handleChangePost(nav)">
      {{ nav.label }}
    </K2Text>
  </K2Row>
</template>

<script>
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Text from '../../../uiComponents/k2Text/k2Text'
import { lang } from '../../../locale'
import uiVariable from '../../../config/uiVariable'

export default {
  name: 'FeedTypeNav',
  components: { K2Text, K2Row },
  props: ['loadPostsMode', 'isMoments', 'isBroadcast'],
  data() {
    return {
      uiVariable: uiVariable,
      postMode: 'Self',
      postNavList: [
        {
          label: lang('My Newsfeeds'),
          type: 'Update',
          mode: 'Self',
          color: uiVariable.color.text,
        },
        {
          label: lang('My Moments'),
          type: 'Moments',
          mode: 'Self',
          color: uiVariable.color.text,
        },
        {
          label: lang('My Broadcasts'),
          type: 'Broadcasts',
          mode: 'Self',
          color: uiVariable.color.text,
        },
        {
          label: lang('All Posts'),
          type: 'Update',
          mode: 'All',
          color: uiVariable.color.text,
        },
        {
          label: lang('All Moments'),
          type: 'Moments',
          mode: 'All',
          color: uiVariable.color.text,
        },
        {
          label: lang('All Broadcasts'),
          type: 'Broadcasts',
          mode: 'All',
          color: uiVariable.color.text,
        },
      ],
    }
  },
  mounted() {
    this.updateNewsNav()
  },
  methods: {
    lang,
    updateNewsNav() {
      this.resetNav()
      let updateNav = this.postNavList?.find(post => post?.type === 'Update' && post?.mode === this.postMode)
      if (!this.isBroadcast && !this.isMoments) {
        updateNav.color = uiVariable.color.link
      } else {
        updateNav.color = uiVariable.color.text
      }
    },
    handleChangePost(nav) {
      this.postMode = nav.mode
      if (nav.type === 'Update' && nav.mode === 'All') {
        this.$emit('changePostsStatus', nav.mode)
      } else {
        this.$emit('changePostsStatus', nav.mode, nav.type)
      }
      this.resetNav()
      nav.color = uiVariable.color.link
    },
    resetNav() {
      this.postNavList?.map(d => (d.color = uiVariable.color.text))
    },
  },
}
</script>
